module.exports = __webpack_public_path__ + "img/whatsapp.4125690c.svg";